export class RegisterPushRequest {
    uniqueId: string;
    platform: string;
    client: string;
}